import { Component } from 'react';
import { connect } from 'react-redux';

import { ErrorBoundaryStyled, ErrorBoundaryTextStyled } from './styled';
import { ErrorBoundaryProps, ErrorBoundaryState } from './types';

export class _ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): Partial<ErrorBoundaryState> {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    // handle error here
    console.log(error, 'error');
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryStyled>
          <ErrorBoundaryTextStyled>
            Что-то пошло не так ;(
          </ErrorBoundaryTextStyled>
        </ErrorBoundaryStyled>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = connect()(_ErrorBoundary);
